<template>
  <chat-notification
    :title="eventTime"
    class="mx-auto text-no-wrap"
    data-chat-date-separator
    :data-timestamp="timestamp"
    :is-clickable="isClickable"
    @click="onClick"
  >
    {{ eventTime }}
  </chat-notification>
</template>

<script lang="ts" setup>
import { computed, toRef } from 'vue'

import { ChatNotification } from '@/shared/components/chat-notification'
import { convertTimestampToString } from '@/shared/utils/date-time'

const props = withDefaults(defineProps<{
  timestamp: number
  isClickable?: boolean
}>(), {
  isClickable: false,
})

const emit = defineEmits<{
  click: [timestamp: number]
}>()

const timestamp = toRef(props, 'timestamp')

const eventTime = computed(() => convertTimestampToString(timestamp.value))

const onClick = () => {
  if (!props.isClickable) {
    return
  }
  emit('click', props.timestamp)
}
</script>
